import { useEffect, useState } from 'react'
import { IoCellular, IoWifi, IoBatteryFull } from 'react-icons/io5'

export default function StatusBar() {
  const [time, setTime] = useState(getFormattedTime())

  function getFormattedTime() {
    const now = new Date()
    return now.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
  }

  useEffect(() => {
    const update = () => setTime(getFormattedTime())

    update()
    const now = new Date()
    const msToNextMinute = (60 - now.getSeconds()) * 1000

    const timeout = setTimeout(() => {
      update()
      const interval = setInterval(update, 60000)

      cleanup.interval = interval
    }, msToNextMinute)

    const cleanup = () => {
      clearTimeout(timeout)
      if (cleanup.interval) clearInterval(cleanup.interval)
    }

    return cleanup
  }, [])

  return (
    <div className="flex justify-between items-center px-4 h-[28px] text-xs text-black font-semibold">
      <div>{time}</div>
      <div className="flex gap-1 items-center text-black">
        <IoCellular size={16} />
        <IoWifi size={16} />
        <IoBatteryFull size={18} />
      </div>
    </div>
  )
}
